import type { HttpError } from '~/common/api-client';

interface RetryOnStatusOptions {
  status: number;
  delaysMs: number[];
}

const wait = (ms: number): Promise<void> =>
  new Promise(resolve => setTimeout(resolve, ms));

export const retryOnStatus = async <T>(
  request: () => Promise<T>,
  { status, delaysMs }: RetryOnStatusOptions
): Promise<T> => {
  for (const delayMs of delaysMs) {
    try {
      return await request();
    } catch (error) {
      if ((error as HttpError)?.status !== status) {
        throw error;
      }
      await wait(delayMs);
    }
  }

  return request();
};
